export const GEO_COOKIE_KEY = 'mc_geo' as const
export const REGION_COOKIE_KEY = 'region' as const
